import { useTLang } from 'intl/intl';

export function useProductsByCategoryLang() {
  return {
    aside: {
      title: useTLang({ id: 'menuPage.global.customizations' }),
    },
  };
}
